export const getCurrentTenant = () => {
  return window?.ENV?.VITE_DOMAIN_FLAG || 'camp';
};

export const isTenantCamp = () => {
  return getCurrentTenant() === 'camp';
};

export const isTenantBoat = () => {
  return getCurrentTenant() === 'boat';
};

export const getTenantConfig = () => {
  const domainFlag = getCurrentTenant();

  const configs = {
    camp: {
      brandName: "Let\'s Camp",
      favicon: '/favicon.ico',
      logoWhite: '/logo-white.png',
      logoDark: '/logo-dark.png',
      logoColorBlack: '/logo-color-black.svg',
      logoStackedColor: '/logo-green.png',
      logo: '/logo-simple-green.png',
      loginBanner: '/login-banner.jpg',
      prefix: 'camps',
      label: {
        brandName: 'Let\'s Camp',
        campground: 'Campground',
        campgrounds: 'Campgrounds',
        camps: 'Camps',
        camp: 'Camp',
        campers: 'campers',
        vehicles: 'Vehicles',
        vehicle: 'Vehicle',
        site: 'Site',
        sites: 'Sites',
        camping: 'Camping',
        accommodation: 'Accommodation',
        campsite: 'Campsite',
      },
      link: {
        support: 'https://support.letscamp.ca/campground-support/',
        firstTimeSetup: 'https://support.letscamp.ca/knowledge-base/first-time-campground-setup/',
        tutorial: 'https://support.letscamp.ca',
      },
    },
    boat: {
      brandName: "Let\'s Boat",
      favicon: '/lets-boat-favicon.png',
      logoWhite: '/lets-boat-white.svg',
      logoDark: '/lets-boat-horizontal-black.svg',
      logoColorBlack: '/lets-boat-horizontal-color-black.svg',
      logoStackedColor: '/lets-boat-color-black.svg',
      logo: '/lets-boat-icon.svg',
      loginBanner: '/boat-launch.jpg',
      prefix: 'marinas',
      label: {
        brandName: 'Let\'s Boat',
        campground: 'Marina',
        campgrounds: 'Marinas',
        camps: 'Marinas',
        camp: 'Marina',
        campers: 'boaters',
        vehicles: 'Vessels',
        vehicle: 'Vessel',
        site: 'Slip',
        sites: 'Slips',
        camping: 'Boating',
        accommodation: 'Reservation',
        campsite: 'Slip',
      },
      link: {
        support: 'https://support.letsmarina.com/marina-support/',
        firstTimeSetup: 'https://support.letsmarina.com/knowledge-base/first-time-campground-setup/',
        tutorial: 'https://support.letsmarina.com',
      },
    },
  };

  return configs[domainFlag] || configs.camp;
};
